 
import type { ScreenName } from "@/common/types/screen-names";
import type { ContentType } from "@ca.vmedia.tv/domains";

export enum Param {
    ITEM_ID = "v_item_id",
    PROGRAM_NAME = "v_program_name",
    MOVIE_NAME = "v_movie_name",
    SERIES_NAME = "v_series_name",
    EPISODE_NAME = "v_episode_name",
    IS_SERIES = "v_is_series",
    CHANNEL_ID = "v_channel_id",
    CHANNEL_NAME = "v_channel_name",
    CONTENT_TYPE = "v_content_type",
    USER_NAME = "v_user_name",
    DEVICE_ID = "v_device_id",
    SESSION_ID = "v_session_id",
    PROGRAM_ITEM = "v_program_item",
    FA_APP_NAME = "app_name",
    FA_SCREEN_NAME = "screen_name",
    FA_SCREEN_CLASS = "screen_class",
    FA_ITEM_ID = "item_id",
    FA_SEARCH_TERM = "search_term",
};

export enum Event {
    LOGIN = "login",
    APP_OPEN = "app_open",
    SCREEN_VIEW = "screen_view",
    SEARCH = "search",
};

export type AnalyticsData = {
    [Param.FA_SCREEN_NAME]: string;
    [Param.FA_SCREEN_CLASS]?: string | null;
    [Param.ITEM_ID]?: string | null;
    [Param.PROGRAM_NAME]?: string | null;
    [Param.MOVIE_NAME]?: string | null;
    [Param.SERIES_NAME]?: string | null;
    [Param.EPISODE_NAME]?: string | null;
    [Param.IS_SERIES]?: boolean;
    [Param.CHANNEL_ID]?: string | number | null;
    [Param.CHANNEL_NAME]?: string | null;
    [Param.CONTENT_TYPE]?: ContentType | null;
};

export interface AnalyticsServiceInterface {
    createEventSearch(searchString: string, id?: string): void;
    createScreenEvent(screenName: ScreenName, screenClass?: string): void;
    createCustomScreenEvent(data: AnalyticsData): void;
    createOpenAppEvent(screenName: ScreenName, screenClass?: string): void;
    createEventLogin(loginId: string | null): void;
};
